import { GDTMessageStatus, HL7MessageDirection } from '@lmt/shared-types';

const hl7MessageStatuses = [
  GDTMessageStatus.Initial,
  GDTMessageStatus.Stored,
  GDTMessageStatus.Processed,
  GDTMessageStatus.Received,
  GDTMessageStatus.Applied,
  GDTMessageStatus.Refused,
  GDTMessageStatus.Error,
];

const hl7MessageIncomingStatuses = [
  GDTMessageStatus.Received,
  GDTMessageStatus.Applied,
  GDTMessageStatus.Refused,
  GDTMessageStatus.Error,
];

const hl7MessageOutgoingStatuses = [
  GDTMessageStatus.Initial,
  GDTMessageStatus.Stored,
  GDTMessageStatus.Processed,
  GDTMessageStatus.Error,
];

export function getHL7MessageStatuses(direction: HL7MessageDirection | null) {
  if (HL7MessageDirection.Incoming == direction) {
    return hl7MessageIncomingStatuses;
  }
  if (HL7MessageDirection.Outgoing == direction) {
    return hl7MessageOutgoingStatuses;
  }
  return hl7MessageStatuses;
}
